/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutPasswordController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Password';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.Form = {};

            $scope.StrengthCheck = $element.data('pwdcheck');
            $scope.StrengthRequiredLevel = $element.data('pwdstrength');
            $scope.StrengthLevel = 0;
            $scope.StrengthText = '';

            var validators = [];
            var initiallyValidated = false;

            function getPasswordStrength(pass) {
                var score = 0;
                if (!pass)
                    return score;

                var letters = {};
                for (var i = 0; i < pass.length; i++) {
                    letters[i] = (letters[i] || 0) + 1;
                    var dd = 5 / letters[i];

                    if (dd.toString() == 'NaN')
                        dd = 0;

                    score += dd;
                }

                var variations = {
                    digits: /\d/.test(pass),
                    lower: /[a-z]/.test(pass),
                    upper: /[A-Z]/.test(pass),
                    nonWords: /\W/.test(pass),
                }

                var variationCount = 0;
                for (var check in variations) {
                    variationCount += (variations[check] == true) ? 1 : 0;
                }
                score += (variationCount - 1) * 10;

                if (score.toString() == 'NaN')
                    score = 0;

                return parseInt(score);
            }

            var level = {
                level0: 'very weak',
                level1: 'very weak',
                level2: 'weak',
                level3: 'normal',
                level4: 'strong',
                level5: 'very strong'
            }

            var getLevel = function (bits) {

                var matched = 0;

                if (bits < 28) {
                    matched = 1;
                }
                else if (bits >= 28 && bits < 43) {
                    matched = 2;
                }
                else if (bits >= 43 && bits < 68) {
                    matched = 3;
                }
                else if (bits >= 68 && bits < 108) {
                    matched = 4;
                }
                else if (bits >= 108) {
                    matched = 5;
                }

                return matched;
            }

            $scope.Control.validateField = function (name) {
                if (initiallyValidated) {
                    _.first(_.filter(validators, function (x) { return x.name == name })).fn();
                }
            };

            $scope.$parent.$watch('EnableCreateAccount', function (newValue, prevValue) {
                if (!newValue && prevValue) {
                    //initialize input fields
                    $scope.Control.Form.Password = '';
                    $scope.Control.Form.PasswordConfirmation = '';
                    //reset validation
                    Validation.reset($scope, 'Control.Form.Password');
                    Validation.reset($scope, 'Control.Form.PasswordConfirmation');
                    $scope.Control.applyChanges();
                }
            });


            validators.push({
                name: 'Control.Form.Password',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Password');
                    Validation.require($scope, 'Control.Form.Password').then(function (response) {
                        if ($scope.StrengthCheck && $scope.Control.Form.Password !== undefined && $scope.Control.Form.Password !== '') {
                            if ($scope.StrengthLevel < $scope.StrengthRequiredLevel) {
                                $scope.Control.Form.PasswordError = true;
                                $scope.Control.Form.PasswordStrengthError = true;
                                $scope.Control.IsValid = false;
                            }
                            else {
                                $scope.Control.Form.PasswordError = false;
                                $scope.Control.Form.PasswordStrengthError = false;
                            }
                        }
                    }, function (error) { });                   
                }
            });

            validators.push({
                name: 'Control.Form.PasswordConfirmation',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.PasswordConfirmation');

                    if ($scope.Control.Form.Password !== undefined && $scope.Control.Form.Password.length > 0) {
                        Validation.isSame($scope, 'Control.Form.PasswordConfirmation', 'Control.Form.Password', {
                            suffix: 'Mismatch'
                        }).then(function (response) { }, function (error) { });
                    }
                }
            });

            if ($scope.StrengthCheck) {
                $scope.$watch('Control.Form.Password', function (value) {

                    var bits = getPasswordStrength($scope.Control.Form.Password);
                    var bitsLevel = getLevel(bits);

                    $scope.StrengthLevel = bitsLevel;
                    $scope.StrengthText = level['level' + bitsLevel];

                    //reset password only when account is always open
                    if (checkoutConfig.createAccountAlwaysOpen) {
                        if (value !== undefined && value.length == 0) {
                            //initialize input fields
                            $scope.Control.Form.Password = '';
                            $scope.Control.Form.PasswordConfirmation = '';
                            //reset validation
                            Validation.reset($scope, 'Control.Form.Password');
                            Validation.reset($scope, 'Control.Form.PasswordConfirmation');
                        }
                    }
                     
                });
            }

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;
                $scope.Control.Form.PasswordStrengthError = false;

                if (!$scope.Order.Current.IsLoggedIn && $scope.Order.Current.CanCreateAccount && $scope.$parent.EnableCreateAccount) {
                    if (!checkoutConfig.createAccountAlwaysOpen || (checkoutConfig.createAccountAlwaysOpen && $scope.Control.Form.Password !== undefined && $scope.Control.Form.Password.length > 0)) {
                        if ($scope.StrengthCheck) {
                            _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Password' })).fn();

                            if ($scope.Control.IsValid)
                                _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PasswordConfirmation' })).fn();
                        } else {
                            _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PasswordConfirmation' })).fn();
                        }
                    }
                }

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }

                initiallyValidated = true;
            };

            $scope.Control.applyChanges = function () {
                $scope.setControlValue(controlName, {
                    Password: $scope.Control.Form.Password,
                    PasswordConfirmation: $scope.Control.Form.PasswordConfirmation
                });
            };

            $element.get(0).focus = function () {
                if (!$scope.Control.IsValid)
                    $('.x-invalid:first *[ng-model]', $element).focus();
                else
                    $('*[ng-model]:first', $element).focus();
            };

            $element.on('click', '.js-password-reveal', function (e) {
                e.preventDefault();
                if ($(this).hasClass('shown')) {
                    $(this).removeClass('shown').siblings('input').prop('type', 'password');
                } else {
                    $(this).addClass('shown').siblings('input').prop('type', 'text');
                }
            });
            ControlService.getCheckoutData("GetPasswordData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);

                $scope.setControlValue(controlName, {
                    Password: '',
                    PasswordConfirmation: ''
                });
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        });
})();